// src/store/modules/TransfertModule.ts
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import TransfertService from '@/Services/TransfertService';

@Module({ namespaced: true })
export default class TransfertModule extends VuexModule {

    transferts: any[] = [];
    error: string | null = null;
    totalRows:number | null = 0;



    @Mutation
    setTransferts(transferts: any[]) {
        this.transferts = transferts;
    }

    @Mutation
    setError(error: string | null) {
        this.error = error;
    }

    @Mutation
    setTotalRows(totalRows: number) {
        this.totalRows = totalRows;
    }

    @Action
    async fetchTransfert({ id, url }: { id: number, url: string }) {
        try {
            const response = await TransfertService.getAll({ id, url });
            
            // Détecter si c'est un export
            const isExport = url.includes('export=excel') || url.includes('export=csv');
            
            if (isExport) {
                return response;
            }
            
            // Pour les données normales, stocker dans le state
            const data = response.data ||  [];
            this.context.commit('setTransferts', data);
            
            if ('totalRows' in response && response.totalRows) {
                this.context.commit('setTotalRows', response.totalRows);
            }
            
            return response; // Return full response for DataTable
        } catch (error: any) {
            this.context.commit('setError', error.message || 'An error occurred while fetching Transferts.');
            throw error;
        }
    }



    get getAll() {
        return this.transferts;
    }

    get getTotalRows() {
        return this.totalRows;
    }

    get getError() {
        return this.error;
    }
}
